import { fetch, postData, putData, deleteFunction } from "../../../Component/function/FunctionApi";
// ⚠️ عدّل المسار ده على حسب مكان ملف الـ Api.js عندك بالظبط

const ENDPOINT = "FinancialTransaction";

// بيبني الكويري string ويشيل أي فلتر فاضي
const buildQueryUrl = (params = {}) => {
  const cleaned = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== "" && value !== null && value !== undefined) {
      cleaned[key] = value;
    }
  });
  const query = new URLSearchParams(cleaned).toString();
  return query ? `${ENDPOINT}?${query}` : ENDPOINT;
};

const financialTransactionService = {
  // GET /api/FinancialTransaction
  getAll: async (params = {}) => {
    const url = buildQueryUrl(params);
    const data = await fetch(url);
    // data = { statusCode, message, data, totalCount, totalPages, currentPage, pageSize, hasPreviousPage, hasNextPage }
    return data;
  },

  // GET /api/FinancialTransaction/{id}
  getById: async (id) => {
    const data = await fetch(`${ENDPOINT}/${id}`);
    return data;
  },

  // POST /api/FinancialTransaction
  create: async (payload, setError = () => {}) => {
    const response = await postData(ENDPOINT, payload, setError);
    return response?.data;
  },

  // PUT /api/FinancialTransaction/{id}
  update: async (id, payload) => {
    const response = await putData(`${ENDPOINT}/${id}`, payload);
    return response?.data;
  },

  // DELETE /api/FinancialTransaction/{id}
  remove: async (id) => {
    const response = await deleteFunction(`${ENDPOINT}/${id}`);
    return response?.data;
  },
};

export default financialTransactionService;